import { CalendarMonth } from "../../../core/date"

export const comparators = {
    month: (a: string, b: string) => {
        return CalendarMonth[a as keyof typeof CalendarMonth] - CalendarMonth[b as keyof typeof CalendarMonth]
    }
}